import { Modal, Center, Stack, Title, Text } from '@mantine/core';
import { IconAlertCircleFilled } from '@tabler/icons-react';

interface ModalErrorProps {
  message: string;
  opened: boolean;
  onClose: () => void;
}

export const ModalError: React.FC<ModalErrorProps> = ({ message, opened, onClose }) => {
  return (
    <Modal opened={opened} onClose={onClose}>
      <Center>
        <Stack justify="center" align="center">
          <IconAlertCircleFilled size={128} color="var(--mantine-color-red-7)" />
          <Title order={2}>ERROR</Title>
          <Text>{message || 'Error inesperado, contacte soporte'}</Text>
        </Stack>
      </Center>
    </Modal>
  );
};
